import { render } from "./header.html?vue&type=template&id=59b7fe11&ts=true"
import script from "./header.ts?vue&type=script&lang=ts"
export * from "./header.ts?vue&type=script&lang=ts"

import "./header.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__